<div class="flex flex-row justify-between">
  <p-breadcrumb
    [model]="[]"
    [home]="home"
  />
</div>
<p-table
  [columns]="cols"
  [value]="service.items"
  [scrollable]="true"
  [virtualScroll]="true"
  [virtualScrollItemSize]="46"
  showGridlines
  scrollHeight="calc(100svh - 50px - 1.5rem)"
  [tableStyle]="{ 'min-width': '50rem' }"
  [globalFilterFields]="['fallaufgabenName', 'userId', 'versionsUnique']"
>
  <ng-template
    #header
    let-columns
  >
    <tr>
      @for (col of columns; track $index) {
      <th style="min-width: 180px;">{{ col.header }}</th>
      }
    </tr>
    <tr>
      <th></th>
      <th>
        <p-columnFilter
          type="text"
          field="fallaufgabenName"
          placeholder="Suche Fallaufgabe"
          ariaLabel="Filter Fallaufgabe"
          [showMenu]="false"
          filterOn="input"
        ></p-columnFilter>
      </th>
      <th>
        <p-columnFilter
          type="text"
          field="userId"
          placeholder="Suche Nutzer ID"
          ariaLabel="Filter userId"
          [showMenu]="false"
          filterOn="input"
        ></p-columnFilter>
      </th>
      <th>
        <p-columnFilter
          type="text"
          field="versionsUnique"
          placeholder="Suche Versions Unique"
          ariaLabel="Filter versionsUnique"
          [showMenu]="false"
          filterOn="input"
        ></p-columnFilter>
      </th>
      <th></th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template
    #body
    let-item
  >
    <tr style="height:46px">
      <td>{{ item.created | date:'dd.MM.yyyy | HH:mm' }}</td>
      <td>{{ item.fallaufgabenName }}</td>
      <td>{{ item.userId }}</td>
      <td>{{ item.versionsUnique }}</td>
      <td>
        @if (item.isAdminTest) {
        <p-tag value="Testlauf" severity="info"></p-tag>
        }
      </td>
      <td>{{ item.availableUntil | date:'dd.MM.yyyy' }}</td>
    </tr>
  </ng-template>
</p-table>
